import { FC, PropsWithChildren } from 'react';

import { Link, usePage } from '@inertiajs/react';

import logoDark from '../assets/logo-dark-theme.svg';
import logoLight from '../assets/logo-light-theme.svg';
import {
    BlockedAccount,
    BlockedAccountDialog,
} from '../components/shared/BlockedAccountDialog';
import { SeoHead } from '../components/shared/SeoHead';
import { useResolvedTheme } from '../hooks/useResolvedTheme';
import { Metadata } from '../types/shared';

type PageProps = {
    metadata: Metadata;
    blockedAccount?: BlockedAccount | null;
};

const Auth: FC<PropsWithChildren> = ({ children }) => {
    const { metadata, blockedAccount } = usePage<PageProps>().props;
    const resolvedTheme = useResolvedTheme();
    const logo = resolvedTheme === 'dark' ? logoDark : logoLight;

    return (
        <>
            <SeoHead metadata={metadata} />
            <BlockedAccountDialog blockedAccount={blockedAccount} />

            <div className="container flex h-screen w-screen flex-col items-center justify-center px-4 sm:px-6">
                <Link
                    href="/"
                    className="absolute top-4 left-4 z-10 flex items-center md:top-8 md:left-8"
                >
                    <img
                        src={logo}
                        alt="CartOn Logo"
                        width={120}
                        height={32}
                        className="h-7 w-auto sm:h-8"
                    />
                </Link>

                {children}
            </div>
        </>
    );
};

export default Auth;
